import { render, staticRenderFns } from "./fields-db.component.vue?vue&type=template&id=62481831"
import script from "./fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62481831')) {
      api.createRecord('62481831', component.options)
    } else {
      api.reload('62481831', component.options)
    }
    module.hot.accept("./fields-db.component.vue?vue&type=template&id=62481831", function () {
      api.rerender('62481831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/fields-db/fields-db.component.vue"
export default component.exports